import DeleteButton from './DeleteButton.jsx'

export default DeleteButton
